import { render, staticRenderFns } from "./SearchSelectCompany.vue?vue&type=template&id=06041baa"
import script from "./SearchSelectCompany.vue?vue&type=script&lang=js"
export * from "./SearchSelectCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports